<template>
  <div
    class="
      tw-h-full tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-8
    "
  >
    <img
      class="sf-empty-state-image"
      :src="$imagesRequire('empty_states/communication.svg')"
    />
    <h2 class="tw-text-2xl tw-mt-0 tw-mb-2">
      {{ copy.noMessagesYet }}
    </h2>
    <p class="tw-mb-2">
      {{ copy.messagesUsing }}
      <RemarkTag v-if="talkingPointTag" :tag="talkingPointTag" />
      {{ copy.tagWillAutomaticallyAppear }}
    </p>

    <NewRemarkButton
      owner-type="ClientMeeting"
      :owner-id="pageData.clientMeetingId"
      :hide-period-selector="true"
      :selected-tag-ids="selectedTagIds"
      :is-client-meeting-remark="true"
      modal-size="l"
    />
  </div>
</template>

<script setup lang="ts">
import { inject } from 'vue'

import type { PreparePageData } from '@app/application/client_meetings/types'

import useI18n from '@app/shared/vue/composables/use-I18n'
import RemarkTag from '@app/application/communication/sections/communication/components/remarks/remark-tag.vue'
import NewRemarkButton from '@app/shared/vue/components/new-remark/new-remark-button.vue'
import { useTalkingPointTag } from '@app/application/client_meetings/composables/use-talking-point-tag'

const I18n = useI18n()
const copy = {
  noMessagesYet: I18n.t('client_meetings.prepare.empty_state.no_messages_yet'),
  messagesUsing: I18n.t('client_meetings.prepare.empty_state.messages_using'),
  tagWillAutomaticallyAppear: I18n.t(
    'client_meetings.prepare.empty_state.tag_will_automatically_appear'
  ),
}

const pageData = inject('pageData') as PreparePageData

const { talkingPointTag, talkingPointTagIds: selectedTagIds } =
  useTalkingPointTag()
</script>
